import { APP_INSTALL_HANDLER, APP_PROMPT_INSTALL_SHOW } from "./mutation-types";
export default {
  installHandler({ commit }, event) {
    // Prevent Chrome >=67 from automatically showing the prompt:
    event.preventDefault();
    // Stash the event so it can be triggered later:
    commit(APP_INSTALL_HANDLER, event);
  },
  promptInstall({ commit }) {
    commit(APP_PROMPT_INSTALL_SHOW);
  }
};
